import React from 'react';
import { useStoreActions } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { pt } from 'yup-locale-pt';
import api from '../../../services/api';
import {
  Paper,
  Box,
  Divider,
  FormControl,
  Button,
  Container,
  Stack
} from '@mui/material';
import { TextField, Datas, AprovacoesCheckbox } from '../../../components';
import FileListField from '../../../components/FileListField';
yup.setLocale(pt);

const Tema08 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  const [anoSelecionado, setAnoSelecionado] = React.useState(
    new Date().getFullYear() - 1
  );
  const [registros, setRegistros] = React.useState(null);

  const schema = yup
    .object({
      recomendacoes: yup
        .string()
        .max(1000, 'Máximo 1000 caracteres')
        .label('Adicione uma recomendação por linha')
        .nullable(),
      docsPlanilhasField: yup
        .array()
        .label('Arraste e solte planilha com indicadores aqui')
        .nullable(),
      docsGraficosField: yup
        .array()
        .label('Arraste e solte imagens (gráficos) aqui')
        .nullable()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const onChangeAno = (event, item) => {
    setAnoSelecionado(item);
  };

  const loadRegistros = async mount => {
    startLoading();
    try {
      let getRegistros = await api.http.get('08/registros/' + anoSelecionado);
      if (mount.isMounted) {
        reset(getRegistros.data);
        setRegistros(getRegistros.data);
      }
      stopLoading();
    } catch (error) {
      if (error.response && error.response.status == 404) {
        if (mount.isMounted) {
          reset({
            recomendacoes: '',
            docsPlanilhas: null,
            docsGraficos: null
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
    }
  };

  const submit = async data => {
    startLoading();
    try {
      let result;
      if (data.id) {
        result = await api.http.put('08/registros/' + data.id, { ...data });
      } else {
        result = await api.http.post('08/registros', {
          ...data,
          ano: anoSelecionado
        });
      }
      reset(result.data);
      setRegistros(result.data);
      stopLoading({ severity: 'success' });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadRegistros(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [anoSelecionado]);

  return (
    <Container maxWidth="false">
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form" autoComplete="off">
          <Stack direction="row" spacing={2}>
            <Datas onChange={onChangeAno} value={anoSelecionado} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AprovacoesCheckbox />
          </Stack>
        </Box>
      </Paper>
      <Paper
        variant="outlined"
        className="preenchimento-grid center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Upload de documentos</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <FileListField
            field="docsPlanilhas"
            initialFiles={registros?.docsPlanilhas}
            useFormRef={useFormRef}
            schema={schema}
          />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <FileListField
            field="docsGraficos"
            useFormRef={useFormRef}
            schema={schema}
            initialFiles={registros?.docsGraficos}
          />
        </FormControl>
        <Divider>
          <h3>Recomendações</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            field="recomendacoes"
            multiline
            rows={4}
            schema={schema}
            useFormRef={useFormRef}
            inputProps={{ maxLength: 1000 }}
          />
        </FormControl>
        <Box>
          <Button
            variant="outlined"
            sx={{ mr: 2 }}
            onClick={() => {
              reset();
            }}
            disabled={!isDirty || isSubmitting}
          >
            CANCELAR
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ m: 1 }}
            onClick={handleSubmit(submit)}
            disabled={!isDirty || isSubmitting}
          >
            Salvar
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Tema08;
